<template>
  <div class="home">
    <BlogPost v-if="user" :post="userLoggedInScreen" />

    <BlogPost v-if="!user" :post="welcomeScreen" />


    <BlogPost :post="post" v-for="(post, index) in blogPostCards" :key="index" />

    <div class="blog-card-wrap">
      <div class="container">
        <h3>View More Recent Blogs</h3>
        <div class="blog-cards">
          <BlogCard :post="post" v-for="(post, index) in blogPostCards" :key="index"/>
        </div>
      </div>
    </div>
    <div v-if="!user" class="updates">
      <div class="container">
        <h2>Register for your free account today!</h2>
        <router-link class="router-button" :to="{ name: 'Register'}">
          Register for asan-cv <Arrow class="arrow arrow-light"/>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import BlogPost from "../components/BlogPost";
import BlogCard from "../components/BlogCard";
import Arrow from "../assets/Icons/arrow-right-light.svg"

export default {
  name: "Home",
  components: {
    BlogPost,
    BlogCard,
    Arrow
  },
  data() {
    return {
      welcomeScreen: {
        title: "Welcome !",
        blogPost:
          "Try our professional Resume builder now. Save time with our easy 3-step resume builder." +
            " No more writer’s block or formatting difficulties in Word. Rapidly make a perfect resume " +
            "employers love.",
        welcomeScreen: true,
        photo: "resumes",
      },
      userLoggedInScreen: {
        userLoggedInScreen: true,
        title: "You are ready to build your CV!",
        blogPost:
            "Only in 15 minutes !",
        photo: "resumes",

      },
      sampleBlogPost: [
        {
          title: "This is a Filter Title!",
          blogHTML: "This is a filter blog post title!",
          blogCoverPhoto: "beautiful-stories",
        },
        {
          title: "This is a Filter Title!",
          blogHTML: "This is a filter blog post title!",
          blogCoverPhoto: "designed-for-everyone",
        },

      ],
    }
  },
  computed: {
    blogPostFeed() {
      return this.$store.getters.blogPostFeed;
    },
    blogPostCards() {
      return this.$store.getters.blogPostCards;
    },
    user() {
      return this.$store.state.user;
    }
  }
};
</script>

<style lang="scss" scoped>
  .blog-card-wrap {
    h3 {
      font-weight: 300;
      font-size: 28px;
      margin-bottom: 32px;
    }
  }

  .updates {
    .container {
      padding: 100px 25px;
      display: flex;
      flex-direction: column;
      align-items: center;
      @media (min-width: 800px) {
        padding: 125px 25px;
        flex-direction: row;
      }

      .router-button {
        display: flex;
        font-size: 14px;
        text-decoration: none;
        @media (min-width: 800px) {
          margin-left: auto;
        }
      }
      h2 {
        font-weight: 300;
        font-size: 32px;
        max-width: 425px;
        width: 100%;
        text-align: center;
        text-transform: uppercase;
        @media(min-width: 800px) {
          text-align: initial;
          font-size: 40px;
        }
      }
    }
  }
</style>
